<template>
  <div v-if="props.visible" class="tab-content" v-show="title == selectedTitle">
    <slot />
  </div>
</template>

<script>
import { inject } from "vue";

export default {
  props: {
    title: { type: String, required: true },
    visible: { type: Boolean, default: true },
    icon: { type: String, default: "" },       // Icon class (e.g., "bi bi-list", "fa fa-home")
    iconLibrary: { type: String, default: "" } // Optional: Force a specific library (e.g., "bi", "fa")
  },
  name: "TabContent",
  setup(props) {
    const selectedTitle = inject("selectedTitle");
    return {
      selectedTitle,
      props,
    };
  },
};
</script>

<style scoped>
.tab-content {
  padding: 20px;
  min-height: 200px;
  border-top: 1px solid #ddd;
}
</style>